import { Suspense } from "react";
import { Outlet } from "react-router";
import { PageSkeleton } from "@/components/page-skeleton";
import { QuickAddButton, QuickAddDialog } from "@/components/quick-add-dialog";
import { TaskSheet } from "@/components/task-sheet";
import { SIDEBAR_STORAGE_KEY, SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useSyncLoop } from "@/hooks/use-sync-loop";
import { AppSidebar } from "./app-sidebar";
import { BottomNav } from "./bottom-nav";
import { Header } from "./header";

function readSidebarOpen(): boolean {
	try {
		return localStorage.getItem(SIDEBAR_STORAGE_KEY) !== "false";
	} catch {
		return true;
	}
}

export function AppShell() {
	useSyncLoop();

	return (
		<SidebarProvider defaultOpen={readSidebarOpen()}>
			<AppSidebar />
			<SidebarInset className="min-w-0">
				<Header />
				{/* Bottom padding keeps content clear of the mobile bar and the quick-add button. */}
				<main className="flex flex-1 flex-col pb-28 md:pb-20">
					<Suspense fallback={<PageSkeleton />}>
						<Outlet />
					</Suspense>
				</main>
			</SidebarInset>
			<BottomNav />
			<QuickAddButton />
			<QuickAddDialog />
			<TaskSheet />
		</SidebarProvider>
	);
}
